import { action, observable, makeObservable } from 'mobx';

class ActiveStreamer {
  @observable streamer = null;
  @observable isSharedScreen = false;

  constructor() {
    makeObservable(this);
  }

  @action
  update(data) {
    this.streamer = data.streamer;
    this.isSharedScreen = data.isSharedScreen;
  }
}

export default ActiveStreamer;
